// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8a62d577","617":"faaa6372","847":"6b5b7fc1"}[chunkId] + ".chunk.js";
};